module.exports = __webpack_public_path__ + "img/bancontact.b7653f5e.svg";